import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

import {DirectoryService, Organization} from '@gt-api';
import {GtAuthenticationService} from './gt-authentication.service';
import {filter, switchMap, tap} from 'rxjs/operators';
import {checkResponse} from '@app/shared/utils/app-utils';

@Injectable({
  providedIn: 'root'
})
export class GtManageOrganizationService {
  private manageLoginName: string;
  private manageOrganizationName: string;
  private organizationSubject = new BehaviorSubject<Organization>(null);

  organization$ = this.organizationSubject.pipe(filter(org => !!org));

  constructor(private directoryService: DirectoryService, private authenticationService: GtAuthenticationService) {
    this.authenticationService
      .getSubscriptions()
      .pipe(
        tap(_ => {
          this.manageLogin = this.authenticationService.login;
          this.manageOname = this.authenticationService.oname;
        })
      )
      .subscribe();
  }

  resetManaged() {
    this.manageLogin = this.authenticationService.login;
    this.manageOname = this.authenticationService.oname;
  }

  set manageLogin(name: string) {
    this.manageLoginName = name;
  }

  get manageLogin() {
    return this.manageLoginName || this.authenticationService.login;
  }

  set manageOname(oname: string) {
    this.updateOrganization(oname);
  }

  get manageOname() {
    return this.manageOrganizationName || this.authenticationService.oname || (this.organization ? this.organization.id : null);
  }

  get organization() {
    return this.organizationSubject.value;
  }

  isSameOrganization(): boolean {
    return this.manageOrganizationName === null || this.manageOrganizationName === this.authenticationService.oname;
  }

  getOrganization(): Observable<Organization> {
    return this.organizationSubject.asObservable();
  }

  private updateOrganization(oname: string) {
    this.manageOrganizationName = oname;
    this.authenticationService
      .getSubscriptions()
      .pipe(
        switchMap(_ => this.directoryService.getOrganization1(oname)),
        checkResponse(),
        tap(result => this.organizationSubject.next(result.organization))
      )
      .subscribe();
  }
}
